
import axios from "axios";
import {useEffect, useState} from "react";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from "@mui/material/Typography";
import {Button, CardActions, CardMedia, Dialog, DialogActions, DialogContent, DialogTitle, Modal} from "@mui/material";
import Box from "@mui/material/Box";
import Dates from "../common/dates";
import Summary from '../summary.json'
import Jijin from '../基金重仓.json'
import Dajijin from '../大基金持股.json'
import SBChicang from '../社保持仓.json'
import moment from 'moment';
import _ from "lodash";
const dict = {};
const MADict = {};
const jjDict = {};
const DajjDict = {};
const sbDict = {};
for(var jj of Jijin){
    jjDict[jj.code] = jj;
}
for(var jj of Dajijin){
    DajjDict[jj.code] = jj;
}
for(var jj of SBChicang){
    sbDict[jj.code] = jj;
}

var today = moment().format("YYYY-MM-DD");
var lastTradingDate = "";
for(var i = Dates.length-1; i>=0; i--){
    if(Dates[i] <= today){
        lastTradingDate = Dates[i];
        break;
    }
}
var lastDayBeforeLastTradingDate = "";
for(var i = Dates.length-1; i>=0; i--){
    if(Dates[i] < lastTradingDate){
        lastDayBeforeLastTradingDate = Dates[i];
        break;
    }
}

function isStockutilsAiDeploymentHost() {
    if (typeof window === "undefined") return false;
    return window.location.hostname === "stockutils.ai.deployment.cn";
}

function isTestMode() {
    if (typeof window === "undefined") return false;
    return new URLSearchParams(window.location.search).get("test") === "true";
}

/** 仅 stockutils.ai.deployment.cn：4%～7% 与「超大单>大单」过滤，自北京时间 2026-05-09 09:30 起生效 */
const STOCKUTILS_DEPLOYMENT_EXTRA_FILTERS_SINCE_MS = new Date(
    "2026-05-09T09:30:00+08:00"
).getTime();

function isStockutilsDeploymentExtraFiltersActive() {
    return Date.now() >= STOCKUTILS_DEPLOYMENT_EXTRA_FILTERS_SINCE_MS;
}

export default function(props){
    const [stocksQueue, setStocksQueue] = useState([]);
    const [filteredStocks, setFilteredStocks] = useState([]);
    const [selectedStock, setSelectedStock] = useState(null);
    const [cates, setCates] = useState([]);
    const [filters, setFilters] = useState({
        主板: true,
        创业板: true,
        科创板: true,
        低价股: false,
        "10日内涨停": false,
        已涨停: false,
        "近期试盘": false
    });
    const [sortFilters, setSortFilters] = useState({
        "按资金": true,
        "按涨跌幅": false,
        "按机构调研次数": false
    });
    const [selectedCategoryStocks, setSelectedCategoryStocks] = useState(null);
    function formatNumberCn(value) {
        const num = Number(value);
        if (isNaN(num)) return value;

        if (Math.abs(num) >= 1e8) {
            return (num / 1e8).toFixed(2) + "Y";
        } else if (Math.abs(num) >= 1e7) {
            return (num / 1e7).toFixed(2) + "KW";
        } else if (Math.abs(num) >= 1e6) {
            return (num / 1e6).toFixed(2) + "BW";
        } else if (Math.abs(num) >= 1e4) {
            return (num / 1e4).toFixed(2) + "W";
        } else {
            return num.toFixed(0);
        }
    }
    const fetchStocksQueue = async ()=>{
        const testMode = isTestMode();
        var filename = "filter"
        const selectedDate = moment(props.date).format("YYYY-MM-DD");
        if(selectedDate != moment().format("YYYY-MM-DD")){
            filename = selectedDate;
        }
        const url = `https://kesyn-1302292689.cos.ap-beijing.myqcloud.com/filter/${filename}.txt?r=` + new Date().getTime();
        const inflowUrl = 'https://kesyn-1302292689.cos.ap-beijing.myqcloud.com/inflow/current.json?r=' + new Date().getTime();
        const recentProbeUrl = `https://kesyn-1302292689.cos.ap-beijing.myqcloud.com/filter/upper_shadow_fill_${selectedDate}.txt?r=` + new Date().getTime();
        const institutionalResearchUrl = 'https://kesyn-1302292689.cos.ap-beijing.myqcloud.com/institutional_research/stock_institutional_research_counts.json?r=' + new Date().getTime();
        const [res, inflowRes, recentProbeRes, institutionalResearchRes] = await Promise.all([
            axios.get(url),
            axios.get(inflowUrl),
            testMode
                ? axios.get(recentProbeUrl).catch((error) => {
                    console.warn('获取近期试盘数据失败:', error);
                    return {data: ''};
                })
                : Promise.resolve({data: ''}),
            axios.get(institutionalResearchUrl).catch((error) => {
                console.warn('获取机构调研统计失败:', error);
                return {data: {stocks: {}}};
            })
        ]);
        const recentProbeCodes = new Set(
            String(recentProbeRes.data || '')
                .split('\n')
                .map(line => line.split(',')[0]?.trim().split('.')[0])
                .filter(Boolean)
        );
        const institutionalResearchByCode = institutionalResearchRes.data?.stocks || {};
        var inflowDict = {};
        for(var item of inflowRes.data){
            inflowDict[item["股票代码"]] = item;
        }
        var lines = res.data.split('\n');
        var passedStock = [];
        var stocks = [];
        for(var line of lines){
            if(line) {
                if(!props.stocks[line.split(',')[0]]){
                    continue;
                }
                if(line.split(',')[2]<3){
                    continue;
                }
                if(line.startsWith("4") || line.startsWith("8")){
                    continue;
                }
                var parts = line.split(',');
                stocks.push({code:parts[0].split(".")[0],  price:parts[1], change: parts[2]});
                var limitUp10d = parts[3] ? parts[3].trim() === "True" : false;
                dict[parts[0].split(".")[0]] = {
                    "code": parts[0].split(".")[0],
                    "涨跌幅": parts[2],
                    price: parts[1],
                    change: parts[2],
                    "limit_up_10d": limitUp10d,
                    "recent_probe": recentProbeCodes.has(parts[0].split(".")[0]),
                    "institutional_research": institutionalResearchByCode[parts[0].split(".")[0]] || null,
                    "主力净流入":  inflowDict[parts[0].split(".")[0]]?inflowDict[parts[0].split(".")[0]]["主力净流入"]:0,
                    "超大单净值": inflowDict[parts[0].split(".")[0]]?inflowDict[parts[0].split(".")[0]]["超大单净值"]:0,
                    "大单净值": inflowDict[parts[0].split(".")[0]]?inflowDict[parts[0].split(".")[0]]["大单净值"]:0,
                    "中单净值": inflowDict[parts[0].split(".")[0]]?inflowDict[parts[0].split(".")[0]]["中单净值"]:0,
                    "小单净值": inflowDict[parts[0].split(".")[0]]?inflowDict[parts[0].split(".")[0]]["小单净值"]:0,
                }
            }
        }
        stocks = _.sortBy(stocks, c=>c.change).reverse();

        for(var st of stocks){
            passedStock.push(st.code);
        }
        var indicesCates = [];
        for(var _stock of passedStock){
            var stock = props.stocks[_stock >= "600000"? _stock + ".SH": _stock + ".SZ"];
            if(!stock){
                continue;
            }
            var _indiciesCates = indicesCates;
            var indices = stock.indices.split("-");
            //indices是多层的行业分类，需要将一层分类放入indicesCates，多层分类依次放入每层的subindices中，并在stocks字段里加入stock
            while(indices.length){
                var indicy = indices.shift();
                var cate = _indiciesCates.find(c=>c.name == indicy);
                if(!cate){
                    cate = {name: indicy, subindices: [], stocks: [_stock]};
                    _indiciesCates.push(cate);
                } else {
                    cate.stocks.push(_stock);
                }

                var all = "所有"
                var AllCate = _indiciesCates.find(c=>c.name == all);

                if(!AllCate){
                    AllCate = {name: all, subindices: [], stocks: [_stock]};
                    _indiciesCates.push(AllCate);
                    AllCate.selected = true;
                } else {
                    AllCate.stocks.push(_stock);
                }


                _indiciesCates = cate.subindices;
            }
        }
        //排序所有分类和子分类，让“所有”在第一位，然后按照stocks的数量排序
        function sort(cates){
            for(var cate of cates){
                cate.subindices = sort(cate.subindices);
            }
            return _.sortBy(cates, c=>c.name=="所有"?0: 1000-c.stocks.length);
        }
        indicesCates = sort(indicesCates);
        setCates(indicesCates);
        setStocksQueue(passedStock);


    };
    useEffect(()=>{
        // 先根据分类筛选
        const baseStocks = selectedCategoryStocks || stocksQueue;
        
        // 再根据筛选条件筛选
        const filtered = baseStocks.filter(code => {
            if(!dict[code]) return false;
            
            const stockData = dict[code];
            const price = parseFloat(stockData.price) || 0;
            const change = parseFloat(stockData.change) || 0;

            if (isStockutilsAiDeploymentHost()) {
                const extraActive = isStockutilsDeploymentExtraFiltersActive();
                if (extraActive && change >= 4 && change <= 7) return false;
                const superOrder = Number(stockData["超大单净值"] || 0);
                const bigOrder = Number(stockData["大单净值"] || 0);
                if (extraActive && superOrder > bigOrder) return false;
            }
            const codeStr = code.toString();
            
            // 科创板：开头为68（优先级最高，避免冲突）
            const isStarMarket = codeStr.startsWith('68');
            // 创业板：开头为3（但不包括68）
            const isChiNext = codeStr.startsWith('3') && !isStarMarket;
            // 主板：开头为0或60（但不包括30和68）
            const isMainBoard = (codeStr.startsWith('0') || codeStr.startsWith('60')) && !isChiNext && !isStarMarket;
            // 低价股：10元以下
            const isLowPrice = price < 10;
            // 10日内涨停
            const isLimitUp10d = stockData.limit_up_10d === true;
            // 近期试盘：仅 test=true 时从 COS 的最新试盘筛选结果中读取
            const isRecentProbe = stockData.recent_probe === true;
            // 已涨停
            let isLimitUp = false;
            if((codeStr.startsWith('60') || codeStr.startsWith('00')) && change > 9.7) {
                isLimitUp = true;
            } else if((codeStr.startsWith('68') || codeStr.startsWith('30')) && change > 19.7) {
                isLimitUp = true;
            } else if(codeStr.startsWith('92') && change > 29.7) {
                isLimitUp = true;
            }
            
            // 板块条件：主板 || 创业板 || 科创板（如果都没选中，则显示所有板块）
            const boardCondition = !filters.主板 && !filters.创业板 && !filters.科创板 
                ? true  // 如果板块都没选中，显示所有板块
                : (filters.主板 && isMainBoard) || (filters.创业板 && isChiNext) || (filters.科创板 && isStarMarket);
            
            // 附加条件：选中的条件之间为 AND；未选择时不限制。
            const hasAdditionalFilters = filters.低价股 || filters["10日内涨停"] || (isTestMode() && filters["近期试盘"]);
            let additionalCondition = true; // 默认不应用附加筛选
            
            if(hasAdditionalFilters) {
                // 如果选中了任意附加条件，则必须满足所有选中的附加条件
                additionalCondition = true;
                if(filters.低价股 && !isLowPrice) additionalCondition = false;
                if(filters["10日内涨停"] && !isLimitUp10d) additionalCondition = false;
                if(isTestMode() && filters["近期试盘"] && !isRecentProbe) additionalCondition = false;
            }
            
            // 已涨停条件：默认false时排除已涨停（&& !isLimitUp），选中时只显示已涨停（&& isLimitUp）
            const limitUpCondition = filters.已涨停 ? isLimitUp : !isLimitUp;
            
            // 板块条件 && 附加条件 && 已涨停条件
            return boardCondition && additionalCondition && limitUpCondition;
        });
        setFilteredStocks(filtered);
    }, [stocksQueue, filters, selectedCategoryStocks])
    useEffect(() => {
        fetchStocksQueue().then();
        // setInterval(function(){
        //     fetchStocksQueue().then();
        // }, 10000)
    }, [props.date]);

    const resetDefaultSelected = (cate)=>{
        for(var c of cate.subindices){
            c.selected = false;
            resetDefaultSelected(c);
        }
        var all = cate.subindices.find(c=>c.name=="所有");
        if(all){
            all.selected = true;
        }
    }
    const renderCates = (_cates)=>{
        const selectedCate = _cates.find(c=>c.selected);
        return <><div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', cursor: 'pointer', marginBottom: 15}}>{
            _cates.map((cate)=>{
                return <div key={cate.name} style={{marginRight: 10}} onClick={()=>{
                    for(var c of _cates){
                        c.selected = false;
                    }
                    cate.selected = true;
                    resetDefaultSelected(cate);
                    setCates([...cates]);
                    setSelectedCategoryStocks(cate.stocks);
                }}>
                    <div style={{fontSize: "15px", color: cate.selected?'#90caf9':'white'}}>{cate.name}</div>
                    {/*{renderCates(cate.subindices)}*/}
                </div>
            })
        }</div>
            {selectedCate&&renderCates(selectedCate.subindices)}
        </>
    }
    const renderFilters = () => {
        const filterLabels = isStockutilsAiDeploymentHost() && !isTestMode()
            ? []
            : [
                '主板',
                '创业板',
                '科创板',
                '低价股',
                '10日内涨停',
                '已涨停',
                ...(isTestMode() ? ['近期试盘'] : [])
            ];
        if (!filterLabels.length) return null;
        return (
            <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', marginBottom: 20, marginTop: 10}}>
                {filterLabels.map(label => (
                    <div
                        key={label}
                        onClick={() => {
                            setFilters(prev => ({
                                ...prev,
                                [label]: !prev[label]
                            }));
                        }}
                        style={{
                            marginRight: 10,
                            marginBottom: 10,
                            padding: '8px 16px',
                            borderRadius: 4,
                            cursor: 'pointer',
                            backgroundColor: filters[label] ? '#90caf9' : 'rgba(255,255,255,0.1)',
                            color: filters[label] ? '#000' : 'white',
                            fontSize: '14px',
                            border: filters[label] ? '1px solid #90caf9' : '1px solid rgba(255,255,255,0.3)',
                            transition: 'all 0.2s'
                        }}
                    >
                        {label}
                    </div>
                ))}
            </div>
        );
    }
    const sortStocks = (codes) => {
        const activeSorts = Object.entries(sortFilters)
            .filter(([, enabled]) => enabled)
            .map(([name]) => name);
        if (!activeSorts.length) return codes;

        const valueFor = (code, sortName) => {
            const row = dict[code] || {};
            if (sortName === "按资金") return Number(row["主力净流入"] || 0);
            if (sortName === "按涨跌幅") return Number(row["涨跌幅"] || 0);
            return Number(row.institutional_research?.half_year || 0);
        };

        // 多选时对每个指标按名次等权计分，兼顾资金、涨幅与机构调研热度。
        const scores = Object.fromEntries(codes.map(code => [code, 0]));
        for (const sortName of activeSorts) {
            [...codes]
                .sort((left, right) => valueFor(right, sortName) - valueFor(left, sortName))
                .forEach((code, index) => {
                    scores[code] += codes.length - index;
                });
        }
        return [...codes].sort((left, right) => scores[right] - scores[left]);
    }
    const renderSortFilters = () => {
        if (!isTestMode()) return null;
        return <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', marginBottom: 20}}>
            {Object.keys(sortFilters).map(label => (
                <div
                    key={label}
                    onClick={() => setSortFilters(prev => ({...prev, [label]: !prev[label]}))}
                    style={{
                        marginRight: 10,
                        marginBottom: 10,
                        padding: '8px 16px',
                        borderRadius: 4,
                        cursor: 'pointer',
                        backgroundColor: sortFilters[label] ? '#fbbf24' : 'rgba(255,255,255,0.1)',
                        color: sortFilters[label] ? '#000' : 'white',
                        fontSize: '14px',
                        border: sortFilters[label] ? '1px solid #fbbf24' : '1px solid rgba(255,255,255,0.3)',
                        transition: 'all 0.2s'
                    }}
                >
                    {label}
                </div>
            ))}
        </div>
    }
    const switchCode = (code) =>{
        if(code >= "600000"){
            if(code[0]=="8"){
                return code + ".BJ";
            }
            return code + ".SH";
        } else if(code[0]=="4" || code[0]=="9"){
            return code + ".BJ";
        } else {
            return code + ".SZ";
        }
    }
    const renderInflow = function(code) {
        const row = dict?.[code] || {};
        const items = [
            { label: "净特大", key: "超大单净值", value: Number(row["超大单净值"] || 0) },
            { label: "净大单", key: "大单净值",   value: Number(row["大单净值"]   || 0) },
            { label: "净中单", key: "中单净值",   value: Number(row["中单净值"]   || 0) },
            { label: "净小单", key: "小单净值",   value: Number(row["小单净值"]   || 0) },
        ];

        const POS = "#E54D42"; // 红
        const NEG = "#22C55E"; // 绿
        const TOTAL_HEIGHT = 30;      // 总高度
        const BASELINE = TOTAL_HEIGHT / 2; // 中线位置（px）

        const maxAbs = Math.max(1, ...items.map(i => Math.abs(i.value))); // 防止除0

        return (
            <div style={{ width: "100%" }}>
                {/* 柱状容器：高度50，内部画一条中线 */}
                <div style={{
                    position: "relative",
                    height: TOTAL_HEIGHT,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "stretch",
                    gap: 15,
                    top: 40
                }}>
                    {/* 中线 */}
                    <div style={{
                        position: "absolute",
                        left: 0,
                        right: 0,
                        top: BASELINE,
                        height: 1,
                        background: "#2a2a2a"
                    }} />

                    {items.map((it) => {
                        const v = it.value;
                        const barH = Math.round(Math.abs(v) / maxAbs * TOTAL_HEIGHT);
                        const color = v >= 0 ? POS : NEG;

                        // 柱体定位：正数从中线往上长，负数从中线往下长
                        const barStyle = {
                            position: "absolute",
                            left: "50%",
                            transform: "translateX(-50%)",
                            width: 24,
                            height: barH,
                            background: color,
                            borderRadius: 3,
                            ...(v >= 0 ? { bottom: TOTAL_HEIGHT - BASELINE } : { top: BASELINE })
                        };

                        // 文字：正数放柱子上方，负数放柱子下方
                        const labelStyle = {
                            position: "absolute",
                            left: "50%",
                            transform: "translateX(-50%)",
                            fontSize: 8,
                            fontWeight: 600,
                            color,
                            whiteSpace: "nowrap",
                            ...(v >= 0
                                ? { bottom: TOTAL_HEIGHT - BASELINE + barH + 4 }
                                : { top: BASELINE + barH + 4 })
                        };

                        return (
                            <div key={it.key} style={{ flex: 1, position: "relative" }}>
                                {/* 数值（格式化显示） */}
                                {v !== 0 && (
                                    <div style={labelStyle} title={`${it.label}：${v}`}>
                                        {formatNumberCn(v)}
                                    </div>
                                )}
                                {/* 柱体 */}
                                <div style={barStyle} title={`${it.label}：${v}`} />
                                {/* X 轴标签 */}
                                {/*<div style={{*/}
                                {/*    position: "absolute",*/}
                                {/*    left: "50%",*/}
                                {/*    transform: "translateX(-50%)",*/}
                                {/*    bottom: -20,*/}
                                {/*    fontSize: 12,*/}
                                {/*    color: "#9aa0a6"*/}
                                {/*}}>*/}
                                {/*    {it.label}*/}
                                {/*</div>*/}
                            </div>
                        );
                    })}
                </div>

                {/* 可选：主力净流入一行（格式化展示） */}
                {/* <div style={{ marginTop: 8, fontSize: 12, color: "#9aa0a6" }}>
        主力净流入：<span style={{ color: (dict?.[code]?.["主力净流入"]||0) >= 0 ? POS : NEG }}>
          {formatNumberCn(dict?.[code]?.["主力净流入"] || 0)}
        </span>
      </div> */}
            </div>
        );
    }
    const renderStocks = (code)=>{
        const stock = props.stocks[switchCode(code)];
        stock.code = code;
        // if(dict[code].price < 10){
        //     return null;
        // }
        // if(dict[code].change > 9){
        //     return null;
        // }

        //lihaoColor: 数量越多红色颜色越深
        var lihaoColor = 255 - Math.min(200, (Summary[switchCode(stock.code)]?Summary[switchCode(stock.code)].tagList.filter(c=>c["影响"]=="利好").length:0) * 20);
        var likongColor = 255 - Math.min(200, (Summary[switchCode(stock.code)]?Summary[switchCode(stock.code)].tagList.filter(c=>c["影响"]=="利空").length:0) * 20);
        var lihaoColorRgb = `rgb(255, ${lihaoColor}, ${lihaoColor})`;
        var likongColorRgb = `rgb(${likongColor}, ${likongColor}, 255)`;

        if(Summary[switchCode(stock.code)]) {
            if (Summary[switchCode(stock.code)].tagList.filter(c => c["影响"] == "利好").length > 4) {
                lihaoColorRgb = `rgb(255, 50, 50)`;
            }
            if (Summary[switchCode(stock.code)].tagList.filter(c => c["影响"] == "利空").length > 4) {
                likongColorRgb = `green`;
            }
        }
        const transparentBase64 =
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAucB9TMSmcQAAAAASUVORK5CYII=";
        // if(lihaoColor < 100){
        // if((Summary[switchCode
        const cardStyle = {
            marginRight: 10,
            marginBottom: 10,
            ...(dict[code]?.limit_up_10d ? { border: '2px solid red' } : {})
        };
        const research = dict[code]?.institutional_research;
        return <Card sx={{ width: 400 }} style={cardStyle}  key={code}>
            <CardContent key={code} onClick={()=>{
                props.setSelectedStock(code);
            }}>
                <div style={{display: 'flex', flexDirection: 'row'}}>
                    <div style={{flex: 1}}>
                        {/*<img src={`https://image.sinajs.cn/newchart/daily/n/${code >= "600000"? "sh" + code: "sz" + code }.gif`} style={{backgroundColor: 'white', width: '100%'}}/>*/}
                        <div style={{fontSize: '20px'}}>
                            {stock.name}
                        </div>
                        <div style={{fontSize: 15, color: 'red'}}>
                            {dict[code]["涨跌幅"]}%
                        </div>
                        <div style={{fontSize: 12, color: 'rgba(255,255,255,0.5)'}}>
                           主力净流入： <span style={{color: 'red'}}>{formatNumberCn(dict[code]["主力净流入"])} </span><br/>
                            {code} {jjDict[code] ? <span style={{color: 'red'}}>基金重仓</span> : ''} {DajjDict[code] ? <span style={{color: 'red'}}>大基金持股</span> : ''}
                            {sbDict[code] ? <span style={{color: 'red'}}>社保持仓</span> : ''}
                            {isTestMode() && research ? <span style={{color: '#fbbf24'}}>机构调研：近1周 {research.week} 次 / 近1月 {research.month} 次 / 近3月 {research.quarter} 次 / 近半年 {research.half_year} 次</span> : ''}
                            <div style={{color:  lihaoColorRgb}}>利好数量：{Summary[switchCode(stock.code)]?Summary[switchCode(stock.code)].tagList.filter(c=>c["影响"]=="利好").length:0}</div>
                            <div style={{color: likongColorRgb}}>利空数量：{Summary[switchCode(stock.code)]?Summary[switchCode(stock.code)].tagList.filter(c=>c["影响"]=="利空").length:0}</div>
                        </div>

                        <div style={{color: '#90caf9', fontSize: 12}}>
                            {stock.indices}
                        </div>
                    </div>
                    <div style={{width: 120}}>
                            {renderInflow(code)}
                        <div>
                            <img src={`https://kesyn-1302292689.cos.ap-beijing.myqcloud.com/fundchart/${code}.png`}
                                 onError={(e) => {
                                     e.target.onerror = null; // 防止死循环
                                     e.target.src = transparentBase64;
                                     e.target.style.opacity = 0;
                                 }}
                                 style={{width: 100, marginTop: 80, height: 50}}/>
                        </div>
                    </div>
                </div>
            </CardContent>
            <CardMedia
                component="img"
                alt="green iguana"
                width="100%"
                style={{backgroundColor:'white'}}
                image={`https://stocks.kesyn.workers.dev/GetPic.aspx?nid=${stock.code>='600000'?1:0}.${stock.code}&type=&unitWidth=-6&ef=EXTENDED_BOLL&formula=KDJ&AT=1&imageType=KXL&timespan=${Math.floor(Date.now()/1000)}`}
                onClick={()=>{
                    setSelectedStock(stock);
                }}
            />
            {/*{renderPattern(dict[code].k1d.patterns)}*/}
            {/*<CardMedia*/}
            {/*    component="img"*/}
            {/*    alt="green iguana"*/}
            {/*    width="100%"*/}
            {/*    style={{backgroundColor:'white'}}*/}
            {/*    image={`https://stocks.kesyn.workers.dev/GetPic.aspx?nid=${stock.code>='600000'?1:0}.${stock.code}&type=M60&unitWidth=-6&ef=EXTENDED_BOLL&formula=KDJ&AT=1&imageType=KXL&timespan=${Math.floor(Date.now()/1000)}`}*/}
            {/*    onClick={()=>{*/}
            {/*        setSelectedStock(stock);*/}
            {/*    }}*/}
            {/*/>*/}
            {/*{renderPattern(dict[code].k60.patterns)}*/}

            {/*<CardActions>*/}
            {/*    <Button size="small">待选</Button>*/}
            {/*    <Button size="small" color="error">隐藏</Button>*/}
            {/*    <Button size="small" variant="outlined">立即下单</Button>*/}
            {/*</CardActions>*/}
        </Card>
    }
    //`https://image.sinajs.cn/newchart/daily/n/${code >= "600000"? "sh" + code: "sz" + code }.gif`
    return <>
        <div>
            {renderCates(cates)}
        </div>
        {renderFilters()}
        {renderSortFilters()}
        <h2>基金重仓</h2>
        <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
        {sortStocks(filteredStocks.filter(code=>jjDict[code] || DajjDict[code] || sbDict[code])).map((code) => {
            return renderStocks(code);
        })}


        </div>
        <h2>其他</h2>
        <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
            {sortStocks(filteredStocks.filter(code=>!(jjDict[code] || DajjDict[code] || sbDict[code]))).map((code) => {
                return renderStocks(code);
            })}
        </div>

        {/*{selectedStock?<Dialog*/}
        {/*    open={selectedStock !== null}*/}
        {/*    onClose={()=>{setSelectedStock(null)}}*/}
        {/*    fullWidth={true}*/}
        {/*    maxWidth={"lg"}*/}
        {/*>*/}
        {/*    <DialogTitle style={{backgroundColor: 'black'}}>{selectedStock.name}</DialogTitle>*/}
        {/*    <DialogContent style={{backgroundColor: 'black'}}>*/}
        {/*        {selectedStock&&<iframe style={{width: '100%', height: 500}}*/}
        {/*            src={`https://quote.eastmoney.com/basic/h5chart-iframe.html?code=${selectedStock.code}&market=${selectedStock.code>='600000'?1:2}&type=r`}></iframe>}*/}
        {/*    </DialogContent>*/}
        {/*    <DialogActions style={{backgroundColor: 'black'}}>*/}
        {/*        <Button size="small">待选</Button>*/}
        {/*        <Button size="small" color="error">隐藏</Button>*/}
        {/*        <Button size="small" variant="outlined">立即下单</Button>*/}
        {/*    </DialogActions>*/}
        {/*</Dialog>:null}*/}
    </>
}
